import { useEffect } from 'react';
import { Link, useMatch, useNavigate, useResolvedPath } from 'react-router-dom';
import { RouteDefinition, VerticalTabs } from '../../../shared/vertical-tabs';
import { ApplicantProfileApplyTo } from './applicant-profile-apply-to';
import { ApplicantProfileCitizenship } from './applicant-profile-citizenship';
import { ApplicantProfileContact } from './applicant-profile-contact';
import { ApplicantProfileIdentity } from './applicant-profile-identity';
import { ApplicantProfileProfession } from './applicant-profile-profession';

export const ApplicantProfile: React.FC = () => {
  const navigate = useNavigate();
  const currentRoutePath = useResolvedPath('').pathname;
  const currentRouteMatch = useMatch(`${currentRoutePath}`);

  const pages = [
    { id: '1', path: 'identity', title: 'Identity' },
    { id: '2', path: 'contact', title: 'Contact' },
    { id: '3', path: 'citizenship', title: 'Citizenship' },
    { id: '4', path: 'profession', title: 'Profession' },
    { id: '5', path: 'apply-to', title: 'Apply To' }
  ];

  const routes: RouteDefinition[] = [
    { id: '1', path: 'identity/*', element: <ApplicantProfileIdentity /> },
    { id: '2', path: 'contact/*', element: <ApplicantProfileContact /> },
    { id: '3', path: 'citizenship/*', element: <ApplicantProfileCitizenship /> },
    { id: '4', path: 'profession/*', element: <ApplicantProfileProfession /> },
    { id: '5', path: 'apply-to/*', element: <ApplicantProfileApplyTo /> }
  ];

  const applicantProfileNavigationMenu = pages.map((page) => ({
    key: page.id,
    label: <Link to={page.path}replace={true}>{page.title}</Link>,
    style: { width: '80%' }
  }));

  useEffect(() => {
    if (currentRouteMatch) {
      navigate(routes[0].path.replace("*", ""), { replace:true }); // Redirect to 1st menu item
    }
  }, [currentRouteMatch, navigate]);

  return <VerticalTabs routes={routes} menuItems={applicantProfileNavigationMenu} />;
};
